import { cva } from 'class-variance-authority';
import { BUTTON_HEIGHT } from './context/useButton';

export const buttonVariants = cva(
  [
    'inline-flex select-none items-center justify-center whitespace-nowrap transition-colors focus:outline-none',
    'group/button disabled:cursor-not-allowed',
    // overlay(텍스트 영향 없음)
    'btn-surface enabled:hover:ov-10 hoverable:ov-10 auto:pressed-ov10 relative bg-[length:100%_100%] bg-no-repeat',
  ].join(' '),
  {
    variants: {
      variant: {
        primary: 'bg-brand-primary text-white disabled:bg-system-gray-100 disabled:text-system-gray-500',
        secondary:
          'border border-system-black bg-transparent text-system-black disabled:border-system-gray-300 disabled:bg-system-white disabled:text-system-gray-500',
        tertiary:
          'border border-system-gray-300 bg-system-white text-system-black disabled:border-system-gray-300 disabled:bg-system-white disabled:text-system-gray-500',
        sub: 'bg-system-gray-300 text-system-black disabled:opacity-50',
        round: 'border border-system-gray-300 bg-system-white text-system-black disabled:opacity-50',
        chat: 'rounded-md bg-system-white text-system-gray-700 disabled:opacity-50',
      },
      /** height 축만 사용 */
      height: {
        h56: 'h-[56px] gap-1 rounded-[8px] px-5',
        h48: 'h-[48px] gap-1 rounded-[6px] px-4',
        h40: 'h-[40px] gap-1 rounded-[6px] px-3',
        // 요구사항
        h32: 'h-[32px] gap-1 rounded-[6px] px-[14px]',
        h28: 'h-[28px] gap-1 rounded-[6px] px-[10px]',
        small: 'h-[20px] gap-0.5 rounded-[4px] p-1',
        medium: 'rounded-[4px] p-2',
      },
      isRound: {
        true: 'rounded-[100px]',
        false: 'rounded-[6px]',
      },
      isIconOnly: { true: '', false: '' },
    },
    compoundVariants: [
      // round + normal
      {
        variant: 'round',
        height: BUTTON_HEIGHT.h56,
        class: 'rounded-[100px] px-5',
      },
      {
        variant: 'round',
        height: BUTTON_HEIGHT.h48,
        class: 'rounded-[100px] px-4',
      },
      {
        variant: 'round',
        height: BUTTON_HEIGHT.h40,
        class: 'rounded-[100px] px-3',
      },
      {
        variant: 'round',
        height: BUTTON_HEIGHT.h32,
        class: 'rounded-[100px] px-[14px]',
      },
      {
        variant: 'round',
        height: BUTTON_HEIGHT.h28,
        class: 'rounded-[100px] px-[10px]',
      },
      // round + icon-only
      {
        variant: 'round',
        height: BUTTON_HEIGHT.h56,
        isIconOnly: true,
        class: 'w-[56px]',
      },
      {
        variant: 'round',
        height: BUTTON_HEIGHT.h48,
        isIconOnly: true,
        class: 'w-[48px]',
      },
      {
        variant: 'round',
        height: BUTTON_HEIGHT.h40,
        isIconOnly: true,
        class: 'w-[40px]',
      },
      {
        variant: 'round',
        height: BUTTON_HEIGHT.h32,
        isIconOnly: true,
        class: 'w-[32px]',
      },
      {
        variant: 'round',
        height: BUTTON_HEIGHT.h28,
        isIconOnly: true,
        class: 'w-[28px]',
      },
    ],
    defaultVariants: {
      variant: 'primary',
      height: 'h48', // 기본값
    },
  },
);
